<div class="container mx-auto px-7 lg:max-w-screen-xl xl:px-0">
  <div class="pb-32 pt-12">
    <img src="/assets/img/svg/logo.svg" alt="Rentokil" class="mx-auto sm:ml-0" />
  </div>
  <div class="mx-auto max-w-[345px]">
    <router-outlet></router-outlet>
  </div>
</div>
